import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import HorizontalCardStartStudyExample from '../examples/HorizontalCardStartStudy';
import HorizontalCardStartStudyWithDeadlineExample from '../examples/HorizontalCardStartStudyWithDeadline';
import HorizontalCardStudyingExample from '../examples/HorizontalCardStudying';
import HorizontalCardStudyingWithDeadlineExample from '../examples/HorizontalCardStudyingWithDeadline';
import HorizontalCardFinishedExample from '../examples/HorizontalCardFinished';
import HorizontalCardSkeletonExample from '../examples/HorizontalCardSkeleton';
import HorizontalCardFinishedWithRatingExample from '../examples/HorizontalCardFinishedWithRating';
import EducationProgramHorizontalCardStudyingExample from '../examples/EducationProgramHorizontalCardStudying';
import EducationProgramHorizontalCardFinishedExample from '../examples/EducationProgramHorizontalCardFinished';
import HorizontalCardNarrowerInitialExample from '../examples/HorizontalCardNarrowerInitial';
import HorizontalCardNarrowerProgressExample from '../examples/HorizontalCardNarrowerProgress';
import HorizontalCardNarrowerRecognizedExample from '../examples/HorizontalCardNarrowerRecognized';
const HorizontalCardStartStudyExampleSource = require('!!raw-loader!../examples/HorizontalCardStartStudy');
const HorizontalCardStartStudyWithDeadlineExampleSource = require('!!raw-loader!../examples/HorizontalCardStartStudyWithDeadline');
const HorizontalCardStudyingExampleSource = require('!!raw-loader!../examples/HorizontalCardStudying');
const HorizontalCardStudyingWithDeadlineExampleSource = require('!!raw-loader!../examples/HorizontalCardStudyingWithDeadline');
const HorizontalCardFinishedExampleSource = require('!!raw-loader!../examples/HorizontalCardFinished');
const HorizontalCardSkeletonExampleSource = require('!!raw-loader!../examples/HorizontalCardSkeleton');
const HorizontalCardFinishedWithRatingExampleSource = require('!!raw-loader!../examples/HorizontalCardFinishedWithRating');
const EducationProgramHorizontalCardStudyingExampleSource = require('!!raw-loader!../examples/EducationProgramHorizontalCardStudying');
const EducationProgramHorizontalCardFinishedExampleSource = require('!!raw-loader!../examples/EducationProgramHorizontalCardFinished');
const HorizontalCardNarrowerInitialExampleSource = require('!!raw-loader!../examples/HorizontalCardNarrowerInitial');
const HorizontalCardNarrowerProgressExampleSource = require('!!raw-loader!../examples/HorizontalCardNarrowerProgress');
const HorizontalCardNarrowerRecognizedExampleSource = require('!!raw-loader!../examples/HorizontalCardNarrowerRecognized');
export default class HorizontalCardsPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Horizontal Card"/>
                <h3>Narrower Horizontal Card</h3>
                <p>Example of Horizontal Course Card Composition as a narrower version</p>
                <div className="docs-example bg-content">
                    <div className="row no-gutters">
                        <div className="col-12">
                            <HorizontalCardNarrowerInitialExample />
                        </div>
                        <div className="col-12">
                            <HorizontalCardNarrowerProgressExample />
                        </div>
                        <div className="col-12">
                            <HorizontalCardNarrowerRecognizedExample />
                        </div>
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardNarrowerInitialExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardNarrowerProgressExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardNarrowerRecognizedExampleSource}</PrismCode>
                </pre>
                <h3>Horizontal Card</h3>
                <p>Example of Horizontal Course Card Composition</p>
                <div className="docs-example bg-content">
                    <div className="row no-gutters">
                        <div className="col-12">
                            <HorizontalCardStartStudyExample />
                        </div>
                        <div className="col-12">
                            <HorizontalCardStartStudyWithDeadlineExample />
                        </div>
                        <div className="col-12">
                            <HorizontalCardStudyingExample />
                        </div>
                        <div className="col-12">
                            <HorizontalCardStudyingWithDeadlineExample />
                        </div>
                        <div className="col-12">
                            <HorizontalCardFinishedExample />
                        </div>
                        <div className="col-12">
                            <HorizontalCardFinishedWithRatingExample />
                        </div>
                        <div className="col-12">
                            <EducationProgramHorizontalCardStudyingExample />
                        </div>
                        <div className="col-12">
                            <EducationProgramHorizontalCardFinishedExample />
                        </div>
                        <div className="col-12">
                            <HorizontalCardSkeletonExample />
                        </div>
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardStartStudyExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardStartStudyWithDeadlineExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardStudyingExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardStudyingWithDeadlineExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardFinishedExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardFinishedWithRatingExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">
                        {EducationProgramHorizontalCardStudyingExampleSource}
                    </PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">
                        {EducationProgramHorizontalCardFinishedExampleSource}
                    </PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{HorizontalCardSkeletonExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
